import { LinkItem } from '../../../AppsList/LinkItem'
import { SideBarTitle } from '../../../../../common/components/side-bar/SideBarTitle'
import { useGroupChannels } from '@wellesley/group'
import { useSwitchState } from 'hooks/useSwitchState'
import { ChevronUp, ChevronDown } from 'lucide-react'
import { ChannelItem } from '../../../AppsList/ChannelItem'

const size = 'lg'
const maxChannels = 3

type GroupChannelsProps = {
  groupId: string
  groupName: string
}
export const GroupChannels = ({ groupId, groupName }: GroupChannelsProps) => {
  const [isOpen, , , toggle] = useSwitchState()
  const { channels } = useGroupChannels({
    groupId,
  })

  if (!channels?.length) return null

  return (
    <>
      <SideBarTitle title="Group channels" />
      {channels
        ?.slice(0, isOpen ? undefined : maxChannels)
        .map((channel) => (
          <ChannelItem
            key={channel.id}
            channel={channel}
            groupName={groupName}
            size={size}
          />
        ))}
      {channels?.length > maxChannels && (
        <div onClick={toggle}>
          <LinkItem
            title={isOpen ? 'Show less' : 'Show more'}
            Icon={isOpen ? ChevronUp : ChevronDown}
            size={size}
          />
        </div>
      )}
    </>
  )
}
